import { useState, useEffect } from "react";
import { ArrowRight } from "lucide-react";

const promos = [
  {
    text: "Try NDAX. Get $10",
    url: "https://refer.ndax.io/ebgT",
  },
  {
    text: "Try Shakepay. Get $20",
    url: "https://shakepay.me/r/FM8INVL",
  },
  {
    text: "Try Newton. Get $25",
    url: "https://web.newton.co/r/YASRDJ",
  },
];

export default function RotatingPromo() {
  const [currentIndex, setCurrentIndex] = useState(() => {
    // Start with a random promo on page load
    return Math.floor(Math.random() * promos.length);
  });

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((current) => (current + 1) % promos.length);
    }, 5000); // Rotate every 5 seconds

    return () => clearInterval(interval);
  }, []);

  const currentPromo = promos[currentIndex];

  return (
    <a
      href={currentPromo.url}
      target="_blank"
      rel="noopener noreferrer"
      className="inline-flex items-center gap-1 text-xs sm:text-sm sm:gap-2 text-blue-600 font-bold hover:text-blue-800 transition-colors group whitespace-nowrap"
    >
      <span className="relative">
        {currentPromo.text}
        <span className="absolute bottom-0 left-0 w-full h-0.5 bg-blue-600 origin-left transform scale-x-0 group-hover:scale-x-100 transition-transform"></span>
      </span>
      <ArrowRight className="h-3 w-3 sm:h-4 sm:w-4 transform group-hover:translate-x-1 transition-transform" />
    </a>
  );
}
